<template>
  <div >
    
     <div  v-if='this.$route.path !== "/login" && this.$route.path !== "/register" && this.$route.path !== "/Resetpassword"  && this.$route.path !== "/login2"'>
    <!---Navigation-->
    <Navbar
    
      :topbarColor="topbarColor"
      :logo="require('@/assets/images/logo/sentenance_logo.png')"
    />

    <!---Sidebar-->
    <SideBar v-if='this.$route.path !== "/login" && this.$route.path !== "/register" && this.$route.path !== "/Resetpassword" && this.$route.path !== "/login2"' parent=".main-wrapper" :sidebarLinks="sidebarLinks" />
   </div >
    <!---Page Container-->
    <div class="main-container-fluid">
     
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Navbar from "@/layout/full/header/Navbar.vue";
import SideBar from "@/layout/full/sidebar/SideBar.vue";
import sidebarLinks from "@/layout/full/sidebar/sidebarlinks.js";

export default {
  name: "MainContainer",
  components: {
    Navbar,
    SideBar
  },
  data: () => ({
    topbarColor: "#ffffff",
    logotitle: "SwiftOneIoT",
    sidebarLinks: sidebarLinks,
    interval: ''
  }),
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
  },
  created() {
   this.interval = setInterval(() => {
      this.$http.post(this.$url+'checkin', {
        username: this.$session.get('username')
      }).catch((err) => {
        // console.log(err)
      })
    }, 30000);
  }
};
</script>
